import { useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useTokenRefresh = () => {
  const { refreshSession, isAuthenticated } = useAuth();

  const checkAndRefreshToken = useCallback(async () => {
    if (!isAuthenticated) return false;

    const idToken = localStorage.getItem('id_token');
    if (!idToken) return false;

    try {
      // Decode JWT to check expiration
      const payload = JSON.parse(atob(idToken.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      const timeUntilExpiry = payload.exp - currentTime;

      // Refresh if token expires in less than 5 minutes
      if (timeUntilExpiry < 300) {
        console.log('Token expiring soon, refreshing...');
        return await refreshSession();
      }

      return true;
    } catch (error) {
      console.error('Error checking token:', error);
      return false;
    }
  }, [refreshSession, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      // Check token immediately
      checkAndRefreshToken();

      // Set up periodic check every 5 minutes
      const interval = setInterval(checkAndRefreshToken, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, checkAndRefreshToken]);

  return { checkAndRefreshToken };
};